import type { ContentFolder } from 'services/folders/entities';

export type ContentWithFolder = ContentFolder['contents'][number] & { folderName?: string };

function matchesSearch(name: string, searchTerm: string): boolean {
  return name.toLowerCase().includes(searchTerm.toLowerCase());
}

function searchRecursive(
  folder: ContentFolder,
  searchTerm: string,
  acc: { folders: ContentFolder[]; contents: ContentWithFolder[] },
  isSearchRoot = false
) {
  for (const content of folder.contents) {
    if (matchesSearch(content.name, searchTerm)) {
      acc.contents.push({ ...content, folderName: isSearchRoot ? undefined : folder.name });
    }
  }
  for (const sub of folder.subfolders) {
    if (matchesSearch(sub.name, searchTerm)) {
      acc.folders.push(sub);
    }
    searchRecursive(sub, searchTerm, acc);
  }
}

export function folderSearch(rootFolder: ContentFolder, searchTerm: string) {
  let folders: ContentFolder[] = [];
  let contents: ContentWithFolder[] = [];

  if (searchTerm === '') {
    folders = rootFolder.subfolders;
    contents = rootFolder.contents;
  } else {
    const acc = { folders, contents };
    searchRecursive(rootFolder, searchTerm, acc, true);
  }

  return {
    folders,
    contents,
  };
}
